module.exports = __webpack_public_path__ + "img/top-teeth.7d70dae5.png";